import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ConnectedDashboard from './ConnectedDashboard'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { ALL_AOLS } from 'constants/aol/aol'
import { selectPrimaryAol } from 'redux/selectors/selectPrimaryAol'
import { setNewsAol } from 'redux/actions'
import DashboardSkeletonContainer from 'redux/containers/pages/dashboard/DashboardSkeletonContainer'

const DashboardAolWrapper = (props) => {
  const primaryAol = useSelector(selectPrimaryAol)
  const { aol } = props

  const dispatch = useDispatch()
  const needsRedirect = !aol || !ALL_AOLS.includes(aol)

  useEffect(() => {
    if (needsRedirect && ALL_AOLS.includes(primaryAol)) {
      dispatch(setNewsAol(primaryAol))
      replaceUrl(`/news/${primaryAol}`)
    } else {
      dispatch(setNewsAol(aol))
    }
  }, [dispatch, needsRedirect, primaryAol, aol])

  if (needsRedirect) return <DashboardSkeletonContainer />
  return <ConnectedDashboard {...props} />
}

export default DashboardAolWrapper
